'use strict';

(function (window, $) {
    var $textBlockTemplate = $('#jwsdw-supplyChain-picker-template-textBlock li'),
        gmap,
        _changeZoom = true,
        _typeFilter = {
            'supplier': true,
            'manufacturer': true
        },
        pointsMap = {
            'gold': '8-10',
            'silver': '5-7',
            'bronze': '1-4'
        },
        markers = [];

    // activate google maps functionalities
    if (window.google && window.google.maps) {
        activateMaps();
    } else {
        window.jwsdwMediator.subscribe('activateGoogleMaps', function() {
            activateMaps();
        });
    }

    $(document).on('click', '.jwsdw-supplyChain-results-supplier', function() {
        var supplierId = $(this).data('id'),
            type = $(this).data('type'),
            supplier = window.jwsdwSupplyChainSettings.suppliers.find(function(sup) {
                return String(sup.id) === String(supplierId);
            }),
            employees,
            division,
            $supplier = $('#jwsdw-supplyChain-picker-template-' + type).clone(),
            $img,
            $partnerSince = $supplier.find('.jwsdw-supplyChain-supplier-partnerSince');

        markers.forEach(function(marker) {
            if (marker.id === String(supplierId)) {
                marker.setIcon(_markerIcon(marker.type + '-selected', 25, 37));

                marker.selected = true;
                marker.setZIndex(9999);
                gmap.setCenter(marker.position);
                if (_changeZoom) {
                    gmap.setZoom(7);
                }
            } else if (marker.selected) {
                marker.setIcon(_markerIcon(marker.type + '-faded', 15, 22));
                marker.selected = false;
                marker.setZIndex(1);
            }
        });

        _changeZoom = true;

        $('.jwsdw-supplyChain-results-supplier').removeClass('jws-bgColorGrey6');
        $(this).addClass('jws-bgColorGrey6');

        if (supplier.supplierImage) {
            $img = $('<img/>');
            $img.attr('src', supplier.supplierImage);
            $supplier.find('.jwsdw-supplyChain-supplier-image').append($img);
        }
        $supplier.find('.jwsdw-supplyChain-supplier-name').text(supplier.name);

        if (supplier.division) {
            division = supplier.division.split(',').map(function(_division) {
                return window.jwsdwSupplyChainSettings.textBlocks.division[_division];
            });
            $supplier.find('.jwsdw-supplyChain-supplier-division').text(division.join(', '));
        }
        $partnerSince.text([
            supplier.partnerSince,
            supplier.partnerSince === 1 ? $partnerSince.data('singular') : $partnerSince.data('plural')
        ].join(' '));
        $supplier.find('.jwsdw-supplyChain-supplier-countryName').text(supplier.countryName);

        if (supplier.evaluation) {
            $supplier.find('.jwsdw-supplyChain-supplier-evaluation')
                .removeClass('jwsdw-colorGold jws-hidden')
                .addClass('jwsdw-color' + _capitalize(supplier.evaluation.toLowerCase()))
                .text(window.jwsdwSupplyChainSettings.textBlocks.medal[supplier.evaluation.toLowerCase()]);
            $supplier.find('.jwsdw-supplyChain-supplier-medal')
                .removeClass('jwsdw-fillColorGold jws-hidden')
                .addClass('jwsdw-fillColor' + _capitalize(supplier.evaluation.toLowerCase()));
        }

        if (type === 'manufacturer') {
            employees = supplier.employees.female + supplier.employees.male;
            if (supplier.supplierShortCut) {
                $supplier.find('.jwsdw-supplyChain-supplier-supplierShortCut-wrapper').removeClass('jws-hidden');
                $supplier.find('.jwsdw-supplyChain-supplier-supplierShortCut').text(supplier.supplierShortCut);
            }
            $supplier.find('.jwsdw-supplyChain-supplier-employees').text(employees);
            $supplier.find('.jwsdw-supplyChain-supplier-employees-ratioFemale').text(
                Math.round(supplier.employees.female / employees * 100)
            );
            $supplier.find('.jwsdw-supplyChain-supplier-employees-ratioMale').text(
                Math.round(supplier.employees.male / employees * 100)
            );

            if (supplier.socialAudit.from && supplier.socialAudit.to) {
                if (supplier.socialAudit.from !== supplier.socialAudit.to) {
                    $supplier.find('.jwsdw-supplyChain-supplier-socialAudit-from').text(_formatDate(supplier.socialAudit.from, true) + '-');
                }
                $supplier.find('.jwsdw-supplyChain-supplier-socialAudit-to').text(_formatDate(supplier.socialAudit.to, false));
            }
            if (supplier.socialAudit.result) {
                $supplier.find('.jwsdw-supplyChain-supplier-socialAudit-link')
                    .removeClass('jws-hidden')
                    .attr('href', supplier.socialAudit.result);
            }

            if (supplier.evaluation) {
                $supplier.find('.jwsdw-supplyChain-supplier-evaluation-text svg')
                    .removeClass('jwsdw-fillColorGold')
                    .addClass('jwsdw-fillColor' + _capitalize(supplier.evaluation.toLowerCase()));
                $supplier.find('.jwsdw-supplyChain-supplier-evaluation-points').text(pointsMap[supplier.evaluation.toLowerCase()]);
                _addTextBlock($supplier, supplier.evaluation, window.jwsdwSupplyChainSettings.textBlocks.conclusion[supplier.evaluation.toLowerCase()]);
            } else {
                $supplier.find('.jwsdw-supplyChain-supplier-evaluation-text').addClass('jws-hidden');
                $supplier.find('.jwsdw-supplyChain-supplier-evaluation-points').addClass('jws-hidden');
            }

        } else {
            if (supplier.certification) {
                $supplier.find('.jwsdw-supplyChain-supplier-certification-container').removeClass('jws-hidden');
                $supplier.find('.jwsdw-supplyChain-supplier-certification').text(supplier.certification);
            }

            supplier.textBlocks.forEach(function(id) {
                _addTextBlock($supplier, supplier.evaluation, window.jwsdwSupplyChainSettings.textBlocks[id]);
            });

            if (supplier.sewageReport.report) {
                $supplier.find('.jwsdw-supplyChain-supplier-sewageReport').removeClass('jws-hidden');
                $supplier.find('.jwsdw-supplyChain-supplier-sewageReport-report-link')
                    .removeClass('jws-hidden')
                    .attr('href', supplier.sewageReport.report);
            }
            if (supplier.sewageReport.result) {
                $supplier.find('.jwsdw-supplyChain-supplier-sewageReport-result-link')
                    .removeClass('jws-hidden')
                    .attr('href', supplier.sewageReport.result);
            }
        }

        window.jwsdwMediator.publish('openPicker', 'infoPicker', {
            'content':
                '<div class="jwsdw-supplyChain-supplier-infoPicker-container"></div>'
        });

        setTimeout(function() {
            $('.jwsdw-supplyChain-supplier-infoPicker-container').html($supplier.html());
            $('.jwsdw-supplyChain-supplier-infoPicker-container').scrollTop(0);
        }, 300);
    });

    window.jwsdwMediator.subscribe('closePicker', function(type) {
        if (type === 'infoPicker') {
            markers.forEach(function(marker) {
                marker.selected = true;
                marker.setIcon(_markerIcon(marker.type, 15, 22));
            });
        }
    });

    $(document).on('click', '#jwsdw-supplyChain-navigation-flyer', toggleNavigation);

    $(document).on('change', '.jwsdw-supplyChain-supplierType', function() {
        var type = this.value,
            active = $(this).is(':checked');

        _typeFilter[type] = active;

        showFilterResults();

        clearMarkers();

        window.jwsdwSupplyChainSettings.suppliers
            .filter(function(supplier) {
                return _typeFilter[supplier.type];
            })
            .forEach(function(supplier) {
                renderGoogleMapMarker(supplier);
            });
    });

    $('#jwsdw-supplyChain-filterBy').on('keyup', showFilterResults);

    /**
     * @description Method to show/hide supplier based on filters
     * @returns {void}
     */
    function showFilterResults() {
        var query = new RegExp($('#jwsdw-supplyChain-filterBy').val(), 'i');

        $('.jwsdw-supplyChain-results-supplier').each(function() {
            if (_typeFilter[$(this).data('type')]) {
                $(this).removeClass('jws-hidden');
            } else {
                $(this).addClass('jws-hidden');
                return;
            }
            if (query.test($(this).data('name')) ||
                query.test($(this).data('short-cut'))) {
                $(this).removeClass('jws-hidden');
            } else {
                $(this).addClass('jws-hidden');
                return;
            }
        });
    }

    $(document).on('change', '#jwsdw-supplyChain-results-sortByName', function () {
        var toggle = $(this).is(':checked') === true ? 1 : -1,
            list = $('.jwsdw-supplyChain-results-supplier').detach();

        $('.jwsdw-supplyChain-sortByName').toggleClass('jws-hidden');
        $('.jwsdw-supplyChain-sortByName').removeClass('jws-opacity-0');
        $('.jwsdw-supplyChain-sortByShortCut').addClass('jws-opacity-0');

        Array.from(list)
            .sort(function (a, b) {
                return $(a).data('name').toLowerCase() > $(b).data('name').toLowerCase() ? -1 * toggle : toggle;
            })
            .forEach(function($supplier) {
                $('.jwsdw-supplyChain-results-body').append($supplier);
            });
    });
    $(document).on('change', '#jwsdw-supplyChain-results-sortByShortCut', function () {
        var toggle = $(this).is(':checked') === true ? 1 : -1,
            list = $('.jwsdw-supplyChain-results-supplier').detach();

        $('.jwsdw-supplyChain-sortByShortCut').toggleClass('jws-hidden');
        $('.jwsdw-supplyChain-sortByShortCut').removeClass('jws-opacity-0');
        $('.jwsdw-supplyChain-sortByName').addClass('jws-opacity-0');

        Array.from(list)
            .sort(function (a, b) {
                return $(a).data('short-cut').toLowerCase() > $(b).data('short-cut').toLowerCase() ? -1 * toggle : toggle;
            })
            .forEach(function($supplier) {
                $('.jwsdw-supplyChain-results-body').append($supplier);
            });
    });

    /**
     * @description Method to toggle navigation display
     * @return {void}
     */
    function toggleNavigation() {
        $('#jwsdw-supplyChain-navigation').toggleClass('jwsdw-show');
    }

    if (/large/.test(window.jwsdwUtil.uiUtils.getViewport())) {
        toggleNavigation();
    }

    /**
     * @description Method to initialize google maps
     * @returns {void}
     */
    function activateMaps() {
        var mapOptions = {
            'center': new window.google.maps.LatLng(
                window.jwsdwSupplyChainSettings.mapDefaults.lat,
                window.jwsdwSupplyChainSettings.mapDefaults.lng
            ),
            'zoom': window.jwsdwSupplyChainSettings.mapDefaults.zoom,
            'maxZoom': window.jwsdwSupplyChainSettings.mapDefaults.maxZoom,
            'minZoom': window.jwsdwSupplyChainSettings.mapDefaults.minZoom,
            'mapTypeId': window.google.maps.MapTypeId.ROADMAP,
            'draggable': true,
            'disableDefaultUI': true,
            'streetViewControl': false,
            'mapTypeControl': false,
            'zoomControl': true
        };

        $('#jwsdw-supplyChain .jwsdw-spinner').addClass('jws-hidden');

        gmap = new window.google.maps.Map(document.getElementById('jwsdw-map'), mapOptions);

        window.google.maps.event.addDomListener(window, 'load', function() {
            window.jwsdwSupplyChainSettings.suppliers.forEach(function(supplier) {
                renderGoogleMapMarker(supplier);
            });
        });

        window.google.maps.event.addDomListener(window, 'resize', function() {
            if (gmap) {
                resizeMap();
            }
        });
    }

    /**
     * @description Method to resize map
     * @returns {void}
     */
    function resizeMap() {
        var center = gmap.getCenter();
        window.google.maps.event.trigger(gmap, 'resize');
        gmap.setCenter(center);
    }

    /**
     * @description Method to render google map marker for store
     * @param {Object} marker store object
     * @param {String} marker.id store id
     * @param {String} marker.type store type
     * @param {Object} marker.location location
     * @param {Number} marker.location.lat latitude
     * @param {Number} marker.location.lng longitude
     * @returns {Object} marker
     */
    function renderGoogleMapMarker(marker) {
        var lat = Number(marker.location.lat),
            lng = Number(marker.location.lng),
            geoLocation = new window.google.maps.LatLng(lat, lng),
            gMarker = new window.google.maps.Marker({
                'position': geoLocation,
                'id': marker.id,
                'type': marker.type,
                'selected': false,
                'map': gmap,
                'animation': window.google.maps.Animation.DROP,
                'icon': _markerIcon(marker.type, 15, 22)
            });

        window.google.maps.event.addListener(gMarker, 'click', function() {
            var $supplierResults = $('.jwsdw-supplyChain-results-body'),
                $supplier = $('.jwsdw-supplyChain-results-supplier[data-id=' + this.id + ']');

            $supplierResults.scrollTop($supplierResults.scrollTop() + $supplier.position().top - $supplierResults.height());

            // temporarily disable change zoom on supplier select
            _changeZoom = false;
            $supplier.click();
        });

        markers.push(gMarker);

        return gMarker;
    }

    /**
     * @description Method to clear markers on map
     * @returns {void}
     */
    function clearMarkers() {
        markers.forEach(function (marker) {
            marker.setMap(null);
        });
        markers = [];
    }

    /**
     * @description Method to generate Icon Object for given type and size
     * @param {String} type store type
     * @param {Number} width width
     * @param {Number} height height
     * @returns {Object} icon object for google maps markers
     * @private
     */
    function _markerIcon(type, width, height) {
        return {
            'url': window.jwsdwSupplyChainSettings.icons[type],
            'scaledSize': new window.google.maps.Size(width, height),
            'origin': new window.google.maps.Point(0, 0),
            'anchor': new window.google.maps.Point(width / 2, height)
        };
    }

    /**
     * @description Method to capitalize first letter of a string
     * @param {String} string string to capitalize
     * @returns {String} capitalized string
     * @private
     */
    function _capitalize(string) {
        if (string) {
            string = string.charAt(0).toUpperCase() + string.substr(1);
        }
        return string || '';
    }

    /**
     * @description Method to format date string to short date
     * @param {String} string date string to format
     * @param {Boolean} short if true format short date
     * @returns {String} formatted date string
     */
    function _formatDate(string, short) {
        var date = new Date(string),
            dateFormatted = date.getDate() + '.' + (date.getMonth() + 1) + '.';

        if (!short) {
            dateFormatted += date.getFullYear();
        }
        return dateFormatted;
    }

    /**
     * @description Method to add a textblock
     * @param {Object} $supplier jQuery object
     * @param {String} evaluation gold/silver/bronze
     * @param {String} text text to included
     * @returns {void}
     */
    function _addTextBlock($supplier, evaluation, text) {
        var $textBlock = $textBlockTemplate.clone();

        $textBlock.find('svg')
            .removeClass('jwsdw-fillColorGold')
            .addClass('jwsdw-fillColor' + _capitalize(evaluation.toLowerCase()));

        $textBlock.find('span').html(text);
        $supplier.find('.jwsdw-supplyChain-supplier-evaluation-text ul').append($textBlock);
    }

    window.supplyChainCreateCSV = function (el) {
        var csvContent = 'data:text/csv;charset=utf-8,';

        csvContent += [
            'id',
            'type',
            'division',
            'name',
            'supplierShortCut',
            'countryCode',
            'countryName',
            'location',
            'location',
            'partnerSince',
            'employees-female',
            'employees-male',
            'evaluation',
            'socialAudit-from',
            'socialAudit-to',
            'socialAudit-result',
            'sewageReport-report',
            'sewageReport-result',
            'certification',
            'supplierImage'
        ].join(',');

        csvContent += '\n';

        csvContent += window.jwsdwSupplyChainSettings.suppliers.map(function(supplier) {
            return [
                supplier.id,
                supplier.type,
                supplier.division,
                supplier.name,
                supplier.supplierShortCut,
                supplier.countryCode,
                supplier.countryName,
                supplier.location.lat,
                supplier.location.lng,
                supplier.partnerSince,
                supplier.employees ? supplier.employees.female : '',
                supplier.employees ? supplier.employees.male : '',
                supplier.evaluation,
                supplier.socialAudit ? supplier.socialAudit.from : '',
                supplier.socialAudit ? supplier.socialAudit.to : '',
                supplier.socialAudit ? supplier.socialAudit.result : '',
                supplier.sewageReport ? supplier.sewageReport.report : '',
                supplier.sewageReport ? supplier.sewageReport.result : '',
                supplier.certification,
                supplier.supplierImage
            ].join(';');
        }).join('\n');
        el.removeAttribute('onclick');
        el.setAttribute('href', encodeURI(csvContent));

        el.click();
    };
}(window, jQuery));